module.exports = __webpack_public_path__ + "static/media/icon-edit-alt.7a14112e.svg";